import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import _ from 'lodash';
import { AnalyticsContainer } from './AnalyticsContainer';

@supertypeClass({ toClient: true, toServer: true })
export class AnalyticsEvent extends Everything {
  @property()
  event: string;

  @property()
  subEvent: string;

  /* Mainly for analytics events*/
  @property()
  startTime: Date;

  @property()
  endTime: Date;

  @property()
  xPos: number;

  @property()
  yPos: number;

  @property()
  propertyName: string;

  @property()
  value: string;

  @property({ getType: () => AnalyticsContainer })
  analyticsContainer: AnalyticsContainer;

  constructor() {
    super();
  }

  static new(props) {
    return new AnalyticsEvent().init(props);
  }

  init(props) {
    const ourProps = AnalyticsEvent.getProperties();

    _.each(
      props,
      function (value, key) {
        if (ourProps[key]) {
          this[key] = value;
        } else {
          throw new Error('invalid data in AnalyticsEvent constructor');
        }
      }.bind(this)
    );

    // Fill out the times and/or default
    if (!this.startTime && !this.endTime) {
      this.startTime = new Date();
    }

    if (!this.endTime) {
      this.endTime = this.startTime;
    }

    if (!this.startTime) {
      this.startTime = this.endTime;
    }
    return this;
  }

  getName() {
    return this.event === 'Analytics' ? this.subEvent : this.event;
  }

  getDescription() {
    return this.propertyName ? this.propertyName + '=' + this.value : this.value;
  }
}
